<section class="agent-profile profiles-container">
  <div [jsonSchema]="[agent.jsonLdSchema, productSchema]"></div>
  <app-loader [isLoading]="isLoading"></app-loader>
  <nav class="navigation is-flex has-flex-align-center hide-on-mobile">
    <app-back-button class="back-to"></app-back-button>
  </nav>
  <section class="primary-info wrapper">
    <app-profile-header
    [imageUrl]="agent.associatePhoto"
    [name]="agent.fullName + agent.agentPrecTitle"
    [isAgentProfile]="true"
    [agentRating]="rating?.overall_rating"
    [agentReviews]="rating?.reviews?.length"
    [isFavourite]="agent.isFavourite"
    [initials]="agent.agentInitials"
    [description]="agent.title"
    (reviewsClicked)="scrollToReviews()"
    >
      <div class="hide-on-mobile text-left" main>
        <br>
        <app-detail-section  [rows]="fastFactRows" [hideTitle]="true" sectionTitle="page-profile.fast-facts"></app-detail-section>
        <br>
        <button id="agentProfile-button-askAQuestion" class="btn btn-primary" (click)="openContactAgentOrOfficeForm(agent)" translate="page-profile.ask-a-question"></button>
      </div>
      <app-toggle-favourite-agent [agent]="agent" [favouriteAgentId]="favouriteAgentId" favourite></app-toggle-favourite-agent>
    </app-profile-header>
    <div class="contact-info hide-on-tablet-up">
      <a *ngIf="agent.primaryNumberToContact" href="tel:{{agent.primaryNumberToContact}}" [title]="'page-profile.aria.callAgent' | translate" >
        <img src="{{'/assets/icons/page-profile/phone_icon.png' | staticp}}" [alt]="'page-profile.aria.callAgent' | translate"/>{{ 'page-profile.phone' | translate }}
      </a>
      <a *ngIf="!agent.primaryNumberToContact" class="disabled">
        <img src="{{'/assets/icons/page-profile/phone_icon.png' | staticp}}" [alt]="'page-profile.aria.callAgent' | translate"/>{{ 'page-profile.phone' | translate }}</a>
      <a style="color: white;">|</a>
      <a (click)="openContactAgentOrOfficeForm(agent)" [class.disabled]="!agent.email" [title]="'page-profile.aria.emailAgent' | translate">
        <img src="{{'/assets/icons/page-profile/email_icon.png' | staticp}}" [alt]="'page-profile.aria.emailAgent' | translate" />{{ 'page-profile.email' | translate }}
      </a>
    </div>
    <div class="secondary-info">
      <div class="office-information" *ngIf="agentOffice">
        <h4 translate="agent-profile.office-information"></h4>
        <a class="office-name" [routerLink]="[agentOffice.detailUrl]">
          {{ (agent.agentIncorporation && agent.agentIncorporation !== 'Personal Real Estate Corporation') ? agent.agentIncorporation : agentOffice.officeName }}
        </a>
        <div id="agentProfile-text-officeAddress">{{ agentOffice.address1 + ' ' + (agentOffice.address2 || '') }}</div>
        <div id="agentProfile-text-officeCityState">{{ agentOffice.city + ', ' + agentOffice.state }}</div>
        <div id="agentProfile-text-officePostalCodeCountry">{{ agentOffice.postalCode + ', ' + agentOffice.country }}</div>
        <br>
        <a class="is-flex has-flex-align-center" *ngIf="agentOffice.website" [href]="agentOffice.website" target="_blank" rel="noopener">
          {{ 'agent-profile.visit-office-website' | translate }}
          <i class="material-icons">chevron_right</i>
        </a>
      </div>
      <hr class="hide-on-mobile full-width block-break" />
      <app-detail-section class="hide-on-tablet-up"  [rows]="fastFactRows" [sectionTitle]="'agents.fast-facts' | translate"></app-detail-section>
      <app-connect-social-bar *ngIf="agent.hasSocialMedia" [name]="agent.firstName" [web]="agent.web" [twitter]="agent.twitter"
        [facebook]="agent.facebook" [linkedIn]="agent.linkedIn"></app-connect-social-bar>
    </div>
  </section>
  <section class="agent-listings listings wrapper has-pos-rel" *ngIf="agentListings.length">
    <h3 translate="agent-profile.agent-listings" [translateParams]="{name: agent.firstName, count: listingsPagination.totalResults}"></h3>
    <app-item-swiper [items]="agentListings" [hasFinishedLoadingItems]="hasRetrievedSuggestedListings"
    (slideChanged)="onSlideChanged($event)" [totalItems]="listingsPagination.totalResults"></app-item-swiper>
  </section>
  <section class="about wrapper hide-on-tablet-up">
    <app-accordion #accordion>
      <app-accordion-item label="agent-profile.agent-bio" [textOnly]="false" *ngIf="agent.hasInformationForBio">
        <div *ngIf="agent.personalSummary" style="white-space: pre-line;">{{agent.personalSummary}}</div>
        <ng-container *ngIf="agent.serviceAreas?.length">
          <b>
            {{ 'page-profile.serving' | translate }}
            <span *ngFor="let area of agent.serviceAreas; let first = first; let last = last;">{{ last ? (first ? area : 'and ' + area) : area + ', '}}</span>.
          </b>
        </ng-container>
        <ng-container *ngIf="agent.specialties?.length">
          <b translate="page-profile.specialties"></b>
          <ul>
            <li *ngFor="let specialties of agent.specialties">{{specialties}}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="agent.hobbies?.length">
          <b translate="page-profile.hobbies"></b>
          <ul>
            <li *ngFor="let hobby of agent.hobbies">{{hobby}}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="agent.civicActivities?.length">
          <b translate="page-profile.civic-activities"></b>
          <ul>
            <li *ngFor="let civic of agent.civicActivities">{{civic}}</li>
          </ul>
        </ng-container>
      </app-accordion-item>
      <app-accordion-item label="agent-profile.awards.all" [textOnly]="false" *ngIf="agent?.combinedAwards?.length > 0">
        <app-agent-award-list [combinedAwards]="agent.combinedAwards"
                              [affiliations]="agent.affiliations"></app-agent-award-list>
      </app-accordion-item>
      <app-accordion-item *ngIf="rating?.reviews?.length > 0" label="agent-profile.reviews" [textOnly]="false" #mobileReviews>
        <app-rating header [setRating]="rating.overall_rating" style="margin-left: 15px;"></app-rating>
        <app-agent-reviews [setRating]="rating"></app-agent-reviews>
      </app-accordion-item>
    </app-accordion>
  </section>
  <section class="about wrapper hide-on-mobile" *ngIf="agent.hasInformationForBio">
    <h3 translate="page-profile.about" [translateParams]="{name: agent.firstName}"></h3>
    <div *ngIf="agent.personalSummary" style="white-space: pre-line;">{{agent.personalSummary}}</div>
    <b>
      <ng-container *ngIf="agent.serviceAreas?.length">
        {{ 'page-profile.serving' | translate }}
        <span *ngFor="let area of agent.serviceAreas; let first = first; let last = last;">{{ last ? (first ? area : ('page-profile.and' | translate) + area) : area + ', '}}</span>.
      </ng-container>
      <span translate="page-profile.specializes-in" [translateParams]="{name: agent.firstName }" *ngIf="agent.specialties?.length"></span>
    </b>
    <div class="specialties" *ngIf="agent.specialties?.length">
      <ul>
        <li *ngFor="let specialties of agent.specialties">{{specialties}}</li>
      </ul>
    </div>
    <div class="hobbies" *ngIf="agent.hobbies?.length">
      <hr/>
      <b translate="page-profile.hobbies"></b>
      <div class="list">
        <ul>
          <li *ngFor="let hobby of agent.hobbies">{{hobby}}</li>
        </ul>
      </div>
    </div>
    <div class="civic-activities" *ngIf="agent.civicActivities?.length">
      <hr/>
      <b translate="page-profile.civic-activities"></b>
      <div class="list">
        <ul>
          <li *ngFor="let civic of agent.civicActivities">{{civic}}</li>
        </ul>
      </div>
    </div>
  </section>
  <section class="awards wrapper hide-on-mobile" *ngIf="!agent.hideAwards && (agent?.combinedAwards?.length > 0 || agent?.affiliations?.length > 0)">
    <h3 translate="agent-profile.awards.all"></h3>
    <app-agent-award-list [combinedAwards]="agent.combinedAwards"
                          [affiliations]="agent.affiliations"
                          *ngIf="agent.combinedAwards?.length > 0 || agent.affiliations?.length > 0"></app-agent-award-list>
  </section>
  <section class="wrapper hide-on-mobile" *ngIf="rating?.reviews?.length > 0" #desktopReviews>
    <h3 translate="reviews.reviews"></h3>
    <app-agent-reviews [setRating]="rating"></app-agent-reviews>
  </section>
  <section class="agent-profiles profiles wrapper" *ngIf="agent.team.length > 0">
    <h3 translate="agent-profile.agent-team" [translateParams]="{name: agent.firstName}"></h3>
    <app-agent-card [isRedesign]="true" *ngFor="let teamAgent of agent.team" [agent]="teamAgent"></app-agent-card>
  </section>
  <div class="hide-on-tablet-up" #contactAgentMobile>
    <app-contact-agent [isFixed]="false" [contactForm]="contactForm" [leadInfo]="leadInfo" (requestSent)="showRequestSent = true" [listingCategory]="listingCategory" [locationType]="ContactFormLocationType.AGENT_PAGE_CONTACT" ></app-contact-agent>
  </div>

  <app-modal width="500" [shouldShowModal]="showContactForm" (closeModal)="showContactForm = false" [allowOutsideClickToClose]="false" [isFullHeight]="true" [templateRef]="contactAgentModalRef">
  </app-modal>
  <ng-template #contactAgentModalRef>
    <app-contact-agent [isFixed]="false" [contactForm]="contactForm" [leadInfo]="leadInfo" (requestSent)="showRequestSent = true; showContactForm = false;" [listingCategory]="listingCategory" [locationType]="ContactFormLocationType.AGENT_PAGE_CONTACT" ></app-contact-agent>
  </ng-template>
  <app-request-sent *ngIf="showRequestSent" (onClose)="showRequestSent = false" [nameToDisplay]="agent.firstName"></app-request-sent>

</section>
